// extracted by mini-css-extract-plugin
module.exports = {"inline":"cphEntry_inline__3cJPO","nonEnglishCph":"cphEntry_nonEnglishCph__2QKZx"};